import { render, staticRenderFns } from "./LongTermGoals.vue?vue&type=template&id=3c12e1b4&scoped=true"
import script from "./LongTermGoals.vue?vue&type=script&lang=js"
export * from "./LongTermGoals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c12e1b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c12e1b4')) {
      api.createRecord('3c12e1b4', component.options)
    } else {
      api.reload('3c12e1b4', component.options)
    }
    module.hot.accept("./LongTermGoals.vue?vue&type=template&id=3c12e1b4&scoped=true", function () {
      api.rerender('3c12e1b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/referral-management/search/components/LongTermGoals.vue"
export default component.exports